import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    margin-top: 6rem;
    width: 90%;
    max-width: 800px;

    h3 {
        margin-left: 2rem;
    }
`;
